import React , {Component} from "react";
import MyContext from '../MyContext.jsx';
import {Link} from "react-router-dom";
import { CgSearch } from 'react-icons/cg';
import Select from "react-select";
import DatePicker from 'react-date-picker';

import './MyAttendanceMyVisit.scss';

class MyVisitReport extends Component{
  constructor(props){
    super(props);
    // this.executiveSelect = React.createRef();


    this.state = {
      executives :  [],
      executive :  {},
      schedules : [],
      from_date : new Date(),
      to_date : new Date(),
      minDate : new Date(new Date().getFullYear()-1, new Date().getMonth(), 1 ),
      maxDate : new Date(new Date().getFullYear(), new Date().getMonth()+1, 0),
    }
    this.formSubmit = this.formSubmit.bind(this);


  }
  componentDidMount(){
    this.context.loading(1);
   
  //   var obj_this = this;
  //   const url3 = `${process.env.REACT_APP_SSS}/api/get/executives`;
  //   this.context.loading(1);
  //   $.ajax({
  //     url : url3,
  //     data : {
  //       sid : this.context.user_details.sid
  //     },
  //     type : "POST"
  //   }).done(function(return_data){
  //     // console.log(return_data);
  //     if(return_data.status == "success"){
  //       obj_this.setState({
  //        executives : return_data.executives,
  //       });
  //       obj_this.context.loading(0);
  //     }else{
  //       obj_this.context.loading(0);
  //       obj_this.props.history.replace("/");
  //     }
  //  }).fail(function(){
  //       obj_this.context.loading(0);
  //       alert("Network error");
  //       obj_this.props.history.replace("/");
  //   });

    var obj_this = this;
    const url2 = `${process.env.REACT_APP_SSS}/api/reports/getMyVisitReport`;
    this.context.loading(1);
    $.ajax({
      url : url2,
      data : {
        sid : this.context.user_details.sid,
        from_date : this.state.from_date.toLocaleDateString('en-CA'),
        to_date : this.state.to_date.toLocaleDateString('en-CA'),
      },
      type : "POST"
    }).done(function(return_data){      
      if(return_data.status == "success"){
        obj_this.setState({
         schedules : return_data.schedules,
        });
        // debugger;
        obj_this.context.loading(0);
      }else{
        obj_this.context.loading(0);
        obj_this.props.history.replace("/");
      }
    }).fail(function(){
      alert("Network error");
      obj_this.context.loading(0);

    });

    
  }



  statusChange(option){
    this.setState({
      selStatus : option
    });
  } 
 

  formSubmit(e){
    e.preventDefault();
    $(".customer_outstandings_table tr").css("backgroud-color","");
    
    var obj_this = this;
    const url2 = `${process.env.REACT_APP_SSS}/api/reports/getMyVisitReport`;
    this.context.loading(1);
    $.ajax({
      url : url2,
      data : {
        sid : this.context.user_details.sid,
        executive : this.state.executive?this.state.executive.value:null,
        from_date : this.state.from_date.toLocaleDateString('en-CA'),
        to_date : this.state.to_date.toLocaleDateString('en-CA'),
      },
      type : "POST"
    }).done(function(return_data){    
      if(return_data.status == "success"){
        obj_this.setState({
         schedules :  return_data.schedules,
        });
        obj_this.context.loading(0);
      }else{
        obj_this.context.loading(0);
        obj_this.props.history.replace("/");
      }
    }).fail(function(){
      obj_this.context.loading(0);
      alert("Network error");
    });
   
    
  }


  fromDateChange(value){
    // console.log(value);
    this.setState({from_date : value});
  }
  toDateChange(value){
    // console.log(value);
    this.setState({to_date : value});
  }



  
    

  render(){
    return(
      <MyContext.Consumer>
        {context => (
        <div className="attendance_visit_report_page_container">
          <div className="page_header">
            
            <div className="page_title"><i className="fas fa-arrow-left" onClick={() => window.history.back()} style={{marginRight: '15px', cursor: 'pointer'}}></i> My Visit Report</div>
          </div> 
          <form className="executive_due_period_form" onSubmit={this.formSubmit}>
            <div className="blocks">
              <div className="input_grid">
                <div className="form_input">
                  <div className="from_to_label">
                    <div className="input_label">From Date</div>
                    <DatePicker
                      className="input custom_input"
                      onChange={(value) => this.fromDateChange(value)}
                      value={this.state.from_date}
                      minDate = {this.state.minDate}
                      maxDate = {this.state.maxDate}
                      clearIcon={null}
                      required
                      format="dd-MM-y"
                    />
                    <div className="input_label">To Date</div>
                    <DatePicker
                      className="input custom_input"
                      onChange={(value) => this.toDateChange(value)}
                      value={this.state.to_date}
                      minDate = {new Date(this.state.from_date)}
                      maxDate = {this.state.maxDate}
                      clearIcon={null}
                      required
                      format="dd-MM-y"
                    />
                  </div>
                
                  {/* <div className="input_label">Executives</div>
                  <Select 
                    options={this.state.executives}  
                    value ={this.state.executive}
                    className="executive" 
                    ref={this.executiveSelect}
                    onChange={e => this.executiveChange(e)}
                    required
                  /> */}
                
                  <div className="submit_button_container">
                    <button className="submit_button">Submit</button>
                  </div>
                </div>
                
                </div>
                
            </div>
          </form>
          
         
          <div className="table_container">
            <table className="customer_outstandings_table">
              <thead>
                <tr>
                  <th style={{maxWidth:"40px"}} align="center">#</th>
                  <th style={{minWidth:"80px"}} align="center">Date</th>
                  {/* <th style={{minWidth:"80px"}}>Employee</th> */}
                  <th style={{minWidth:"100px"}} align="center">Customer Name</th>
                  <th style={{minWidth:"100px"}} align="center">Customer Type</th>
                  <th style={{minWidth:"100px"}}  align="center">Purpose Of Visit</th>
                  <th style={{minWidth:"100px"}} align="center">Remarks</th>
                  <th style={{minWidth:"100px"}}  align="center">Location</th>
                  <th style={{minWidth:"80px"}}  align="center">Check In</th>
                  <th style={{minWidth:"80px"}}  align="center">Check Out</th>
                  <th style={{minWidth:"100px"}}  align="center">Duration</th>
                  <th style={{minWidth:"80px"}} align="center">Created at</th>
                </tr>
              </thead>
              <tbody>
              <tr style={{display:this.state.schedules.length?"none":"table-row"}}>
                <td colSpan="4" align="center">No result!</td>
              </tr>
              {this.state.schedules && this.state.schedules.map((cust,index) => (
                <tr key={index}>
                  <td valign="top" align="center">{index+1}</td>
                  <td valign="top" align="center">{new Date(cust.date).toLocaleDateString('en-GB')}</td>
                  {/* <td valign="top" >{cust.staffname}</td> */}
                  <td valign="top" align="left">{cust.customer_name}</td>
                  <td valign="top" align="center">{cust.customer_type}</td>
                  <td valign="top" >{cust.purpose}</td>
                  <td valign="top" align="center">{cust.activity}</td>
                  <td valign="top" >{cust.location}</td>
                  <td valign="top" align="center" >{cust.check_in_time}</td>
                  <td valign="top" align="center" >{cust.check_out_time}</td>
                  <td valign="top" align="center" >{cust.duration}</td>
                  <td valign="top" align="center">{cust.created_at_time}</td>

                </tr>
              ))}
              </tbody>
            </table>
          </div>
        </div>

      )}
    </MyContext.Consumer>
  )}
}

export default MyVisitReport;
MyVisitReport.contextType = MyContext;
